const isDashboard = (url) => /:\/\/[^./]*dashboard(-templates)?\./
  .test(url);

export default isDashboard;
